export const coords = [38.9072, -77.0369]
export default coords